import Button from '@hellodarwin/core/lib/components/common/button';
import styled from 'styled-components';

export const Layout = styled.div`
  background: ${({ theme }) => theme.colors.beige_2};
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

export const AppHeader = styled.header`
  align-items: center;
  background: ${({ theme }) => theme.colors.white_1};
  border-bottom: ${({ theme }) => theme.spacing.xs / 4}px solid
    ${({ theme }) => theme.colors.grey_4};
  box-shadow: ${({ theme }) => theme.appearance.box_shadow};
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  height: ${({ theme }) => theme.appearance.appHeaderHeight}px;
  overflow: hidden;
  padding: 0 ${({ theme }) => theme.spacing.sm}px;
  z-index: 10;

  > *:first-child {
    align-self: center;
    grid-column: 2;
    justify-self: center;
  }

  > *:nth-child(2) {
    align-self: center;
    grid-column: 3;
    justify-self: flex-end;
  }
`;

export const HeaderUtilities = styled.div`
  align-items: center;
  display: flex;
`;

export const LocaleButton = styled(Button)`
  border: none;
  height: ${({ theme }) => theme.buttons.height_medium};
  text-transform: uppercase;
  transition: ${({ theme }) => theme.appearance.transition};
  width: ${({ theme }) => theme.buttons.height_medium};
  margin-right: ${({ theme }) => theme.spacing.sm}px;
`;

export const HeaderDivider = styled.div`
  align-self: center;
  background: ${({ theme }) => theme.colors.grey_4};
  height: ${({ theme }) => theme.spacing.lg}px;
  width: ${({ theme }) => theme.spacing.xs / 4}px;
`;

export const LogoutButton = styled(Button)`
  margin-left: ${({ theme }) => theme.spacing.md}px;
  margin-right: ${({ theme }) => theme.spacing.sm}px;
`;

export const Screen = styled.main`
  align-items: center;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: center;
  overflow-y: auto;
  padding: ${({ theme }) => theme.spacing.xxxl}px;
  position: relative;

  @media (max-width: ${({ theme }) => theme.breakpoints.l}px) {
    align-items: flex-start;
    flex-direction: column;
    justify-content: flex-start;
    padding: ${({ theme }) => theme.spacing.xl}px
      ${({ theme }) => theme.spacing.lg}px;
  }
`;

export const Content = styled.section`
  display: flex;
  flex: 0 1 50%;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.lg}px;
  justify-content: center;
  max-width: ${({ theme }) => theme.caps.xxs}px;
  width: 100%;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
    gap: ${({ theme }) => theme.spacing.xl}px;
    padding-block-start: ${({ theme }) => theme.spacing.xl}px;
  }
`;

export const Preview = styled.aside`
  align-items: center;
  display: flex;
  flex: 0 1 50%;
  justify-content: center;
  min-width: 0;
  padding-inline: ${({ theme }) => theme.spacing.xl}px;
  width: 100%;

  @media (max-width: ${({ theme }) => theme.breakpoints.l}px) {
    display: none;
  }
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.sm}px;
`;

export const EmailHighlight = styled.strong`
  color: ${({ theme }) => theme.colors.grey_1};
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.md}px;
  width: fit-content;

  .hd-button {
    min-width: ${({ theme }) => theme.buttons.width_medium};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
    width: 100%;

    .hd-button {
      width: 100%;
    }
  }
`;

export const ResendAction = styled.div`
  align-items: center;
  display: flex;
  gap: ${({ theme }) => theme.spacing.xs}px;

  .hd-button {
    color: ${({ theme }) => theme.colors.purple_1};
    min-width: auto;
    width: fit-content;

    span {
      margin: 0;
    }
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
    align-items: flex-start;
    flex-direction: column;
  }
`;
